import type { ComponentProps } from 'react';
import { useNavigate } from 'react-router-dom';
import { LinkComponent } from 'forstok-ui-lib';
import type {  TMouseEvent } from 'forstok-ui-lib';
import cookies from '../../../utils/cookies';
import { client } from '../../../utils/forstok';
import Auth from './auth/auth';

export const destroyUser = async (callback?: () => void) => {
  await client.clearStore();
  if (import.meta.env.DEV) {
    cookies.remove('token', { path: '/' });
    cookies.remove('permission', { path: '/' });
    cookies.remove('password', { path: '/' });
    cookies.remove('users', { path: '/' });
    cookies.remove('warehouse', { path: '/' });
  } else {
    cookies.remove('token', { path: '/', domain: '.forstok.com' });
    cookies.remove('permission', { path: '/', domain: '.forstok.com' });
    cookies.remove('password', { path: '/', domain: '.forstok.com' });
    cookies.remove('users', { path: '/', domain:'.forstok.com' });
    cookies.remove('warehouse', { path: '/', domain:'.forstok.com' });
  }
  window.sessionStorage.clear();
  window.localStorage.clear();
  callback && callback();
};

export const expiredUser = () => {
  return destroyUser(() => {
    window.location.href = '/users/login?k=exp';
  });
};

const Logout = ({ mode }:{ mode?: ComponentProps<typeof LinkComponent>['mode'] }) => {
  let navigate = useNavigate();

  const handleClick: TMouseEvent = e => {
    e.preventDefault();
    destroyUser(() => {
      Auth.logout(() => navigate('/users/login'));
    });
  };

  return (
    <LinkComponent mode={mode || 'clearR'} onClick={handleClick}>Logout</LinkComponent >
  );
};

export default Logout;